<template>
  <mi-dialog
    :model-value="showModal"
    no-esc-dismiss
    no-backdrop-dismiss
    class="save-new-list-modal"
    :on-handle-close="closeModal"
  >
    <div class="save-new-list-modal__header">
      <h3>SAVE AS NEW LIST</h3>
    </div>
    <div class="save-new-list-modal__content">
      <mi-text-field
        ref="nameField"
        v-model="configurationsListName"
        label="List name"
        placeholder="Insert a new name for your list"
        outlined
        :rules="[required, maxLength(100, 'Max 100 characters limit.')]"
      ></mi-text-field>
    </div>

    <template #actions>
      <mi-btn flat @click="closeModal">Cancel</mi-btn>
      <mi-btn :loading="loadingSave" color="accent" @click="onHandleSave">Save</mi-btn>
    </template>
  </mi-dialog>
</template>

<script>
  import MiTextField from '@/packages/@mi-library/MiTextField/MiTextField.vue'
  import { ref } from 'vue'
  import notify from '@/utils/notify'
  import { maxLength, required } from '@/utils/validators'
  import { PAC_SAVED_LISTS_ROUTE } from '@/router/routeNames'
  import { useRouter } from 'vue-router'
  import { createConfigurationsList } from '@/api'

  export default {
    name: 'SaveNewListModal',
    components: { MiTextField },
    props: {
      showModal: {
        type: Boolean,
        default: false
      },
      selectedConfigurationsIdsSet: {
        type: Object,
        required: true,
        default: () => {}
      },
      handleDeselectAll: {
        type: Function,
        required: true,
        default: () => ({})
      }
    },
    emits: ['update:show-modal'],
    setup(props, { emit }) {
      const loadingSave = ref(false)
      const configurationsListName = ref('')
      const nameField = ref(null)
      const router = useRouter()

      const closeModal = () => {
        emit('update:show-modal')
      }

      const onHandleSave = async () => {
        const isValid = await nameField.value?.validate()

        if (!isValid) return

        try {
          loadingSave.value = true

          await createConfigurationsList({
            name: configurationsListName.value,
            configurationIds: props.selectedConfigurationsIdsSet
          })

          const savedListsRouteHref = router.resolve({
            name: PAC_SAVED_LISTS_ROUTE.name
          }).href

          notify({
            title: 'SUCCESS',
            content: `
              <div>
                <div>Your new list has been saved to “Saved Lists”.</div>
                <div style="margin-top: 8px;">
                  <a href="${ savedListsRouteHref }"
                  style="color: #ffffff; text-decoration: underline; font-weight: 500;">
                    Go to Saved Lists
                  </a>
                </div>
              </div>
            `,
            type: 'positive',
            html: true
          })

          props.handleDeselectAll(true)
          closeModal()
        }
        catch (err) {
          console.error(err)
        }
        finally {
          loadingSave.value = false
        }
      }

      return {
        onHandleSave,
        loadingSave,
        configurationsListName,
        nameField,
        closeModal
      }
    },
    methods: { required, maxLength }
  }
</script>

<style lang="scss">
  .save-new-list-modal {
    .q-dialog__inner > .mi-card {
      width: 592px;
      max-width: 592px;
      height: 240px;
    }

    &__header {
      h3 {
        margin: 0;
      }
    }

    &__content {
      padding-top: 8px;

      .mi-card__actions {
        padding-top: 16px;
        padding-right: 24px;
      }
    }
  }
</style>
